import React, { FC, useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { concessionaireName, isStylesConfigurationLoading } from 'apollo/cache';

const Component: FC = () => {
  const { host } = window.location;
  const concessionaire = host.split('.')[0];
  const name = useReactiveVar(concessionaireName);

  const setConcessionaireName = () => {
    if (!concessionaire.includes('localhost') && concessionaire !== 'lite') {
      concessionaireName(concessionaire);
    }
    concessionaireName('kaufmann');
  };

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    if (!name && !(location.hostname === 'localhost')) {
      isStylesConfigurationLoading(true);
    }
  }, [name]);

  useEffect(() => {
    setConcessionaireName();
  }, []);

  return <></>;
};

export default Component;
